export default "__VITE_ASSET__bd2458dd__"